import { render, staticRenderFns } from "./FormatUnderlineIcon.vue?vue&type=template&id=0d0c25b2"
import script from "./FormatUnderlineIcon.vue?vue&type=script&lang=js"
export * from "./FormatUnderlineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports